import AuthAxios from '../../models/Axios'
import * as Types from '../../constants/actionTypes';
import { AUTH_SERVICE_URL, LOCAL_URL, API_REQUESTS } from '../../helper/constant'



export const GET_REQUEST_ACCESS_LIST = (payload) => async (dispatch) => {
  try {
   const data = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_ACCESS}/getList`, { params: payload });
   return data.data
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_ACCESS_LIST_ERROR,
      error:exception.message
    })
  }
}

export const GET_ACCESS_REQUESTS = async (payload) => {
  try {
    const response = await AuthAxios.axios.get(`${LOCAL_URL}/inquiry/getAccessRequests`, { params: payload });
    return response.data && response.data.data;
  } catch (exception) {
    return exception;
  }
};

export const LIST_REQUEST_ACCESS = (payload) => async(dispatch) => {
  try {
    const response = await AuthAxios.axios.get(`${LOCAL_URL}/inquiry/getAccessRequests`, { params: payload });
    dispatch({ type: Types.REQUEST_ACCESS_LIST, data: response.data })
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_ACCESS_LIST_ERROR,
      error: exception.message
    })
  }
};
export const LIST_USER_REQUEST_ACCESS = (payload) => async(dispatch) => {
  try {
    const response = await AuthAxios.axios.get(`${LOCAL_URL}/inquiry/getUserAccessRequests`, { params: payload });
    dispatch({ type: Types.REQUEST_ACCESS_LIST, data: response.data })
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_ACCESS_LIST_ERROR,
      error: exception.message
    })
  }
};

export const GET_TRACKING_STATUS_LIST = async(payload) => {
  try {
    const response = await AuthAxios.axios.get(`${LOCAL_URL}/inquiry/getListInquiryTrackingStatus`, { params: payload });
    return response?.data?.data?.data;
  } catch (exception) {
    return exception;
  }
};

export const GET_REQUEST_ACCESS_DETAIL = (payload) => async (dispatch) => {
  try {
   const data = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REQUEST_ACCESS}/getDetail/${payload.id}`);
   return data.data.data
  } catch (exception) {
    dispatch({
      type: Types.REQUEST_ACCESS_DETAIL_ERROR,
      error:exception.message
    })
  }
}

export const GET_REGION_LIST = () => async (dispatch) => {
  try {
      const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.REGION_URL}/listRegions`)
      dispatch({ type: Types.GET_REGION_LIST, data: response.data })
  } catch (error) {
      dispatch({ type: Types.REGION_LIST_ERROR, error })
  }
}

export const GET_ALL_COUNTRIES = (payload) => async (dispatch) => {
  const URL = `${LOCAL_URL}/countries/getcountrieslist`;
  try {
      const response = await AuthAxios.axios.get(URL, { params: payload });
      dispatch({ type: Types.ALL_COUNTRY_LIST, data: response.data })
  } catch (error) {
      let response = error.response
      let message = response && response.data
      dispatch({ type: Types.ALL_COUNTRY_LIST_FAILED, errorMessage: message })
  }
}

export const GET_PORTAL_COUNTRY_LIST = (payload) => async (dispatch) => {
  const URL = `${LOCAL_URL}/portalcountry/getPortalCountryList`;
  try {
      const response = await AuthAxios.axios.get(URL, { params: payload });
      dispatch({ type: Types.PORTAL_COUNTRY_LIST, data: response.data })
  } catch (error) {
      let response = error.response
      let message = response && response.data
      dispatch({ type: Types.PORTAL_COUNTRIES_FAILED, errorMessage: message })
  }
}

export const GET_PORTAL_GROUP_LIST = (payload) => async (dispatch) => {
  try {
   const response = await AuthAxios.axios.get(`${LOCAL_URL}${API_REQUESTS.PORTAL_GROUP}/getGroupList`, { params: payload });
   dispatch({ type: Types.GROUP_DATA, data: response.data })
  } catch (exception) {
    dispatch({
      type: Types.GROUP_ERR,
      error: exception.message
    })
  }
}

export const GET_PORTAL_USER_GROUPS= async (payload) => {
  try {
    const response = await AuthAxios.axios.post(`${LOCAL_URL}/portalgroups/groupDetails`, payload);
    return response?.data
  } catch (exception) {
    return exception;
  }
};

export const GET_ACCESS_REQUEST_USER_INFO = async (payload) => {
  try {
      const response = await AuthAxios.axios.get(`${AUTH_SERVICE_URL}/portal/users/getPortalUserInfo`, { params: payload });
      return response?.data?.data;
  } catch (error) {
      return error;
  }
}

export const SET_OPEN_REQUEST_ACCESS = (payload) => async (dispatch) => {
    dispatch({ type: Types.SET_OPEN_REQUEST_ACCESS, data: payload })
}

export const UPDATE_ACCESS_REQUEST = async (payload) => {
  try {
    return await AuthAxios.axios.patch(`${LOCAL_URL}/inquiry/updateStatus/${payload.id}`, payload);
  } catch (exception) {
    return {error: exception };
  }
}

export const UPDATE_PORTAL_USER_GROUP= async (payload) => {
  try {
    const response = await AuthAxios.axios.post(`${LOCAL_URL}/portalusergroups/setGroup`, payload);
    return response?.data;
  } catch (exception) {
    return {error: exception };
  }
}

export const UPDATE_PORTAL_USER_COUNTRY= async (payload) => {
  try {
    const response = await AuthAxios.axios.post(`${LOCAL_URL}/portalusercountries/createPortalUserCountries`, payload);
    return response?.data;
  } catch (exception) {
    return {error: exception };
  }
}
